import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
class BlueIndentedSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true,
    };
  }

  toggleCollapse(event) {
    console.log(event.target);
    let btn = $(event.target);
    btn.next(".collapse").collapse("toggle");
    let icon = btn.find(".fas");
    this.setState({ open: !this.state.open });
    if (icon.hasClass("fa-sort-up")) {
      icon.removeClass("fa-sort-up").addClass("fa-sort-down");
    } else {
      icon.removeClass("fa-sort-down").addClass("fa-sort-up");
    }
    console.log(this.state.open);
  }

  render() {
    return (
      <>
        <div style={{ display: this.props.children === undefined ? "none" : undefined }} className="row styled-indent-blue dashboard-section">
          <div className={this.props.ppcDash == true ? "col-12 pt-1 dash-sides" : "col-12 pt-1"}>
            <h4 className="float-left">{this.props.sectionTitle}</h4>
            <div className="react-collapser float-right" onClick={(e) => this.toggleCollapse(e)}>
              <p style={{ fontSize: "16px" }} className="text-primary mb-0">
                {this.state.open === true ? "Collapse " : "Expand "}Section&nbsp;<i className="fas fa-sort-up"></i>
              </p>
            </div>
            <div className="no-gutters clear-both off-color-bg collapse show dashboard-section-inner">{this.props.children}</div>
            <div className="clear-both"></div>
            <div style={{ borderBottom: "#E1E1E1 solid 2px" }}></div>
          </div>
        </div>
        <div className="clear-both"></div>
      </>
    );
  }
}

export default BlueIndentedSection;
